import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { dsDtos } from '@vectronic/openApi-admin';

@Component({
  selector: 'table-datatable-schedules',
  templateUrl: './datatable-schedules.component.html',
  styleUrls: ['./datatable-schedules.component.scss'],
  imports: [MatButtonModule, CommonModule],
})
export class DatatableSchedulesComponent {
  schedules = input<dsDtos.Schedule[]>();
  idDevice = input<number>();
  isCompactMode = input(false);
  virtualFenceConstructionRules = input<dsDtos.VirtualFenceConstructionRule[]>();

  openCommandModal = output<{
    schedules: dsDtos.Schedule[];
    idDevice: number;
    virtualFenceConstructionRules: dsDtos.VirtualFenceConstructionRule[];
  }>();

  onClickSchedule() {
    this.openCommandModal.emit({
      schedules: this.schedules(),
      idDevice: this.idDevice(),
      virtualFenceConstructionRules: this.virtualFenceConstructionRules(),
    });
  }
}
